"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Spacing = /** @class */ (function () {
    function Spacing(displayName, px) {
        this.displayName = displayName;
        this.px = px;
    }
    Spacing.fromPixels = function (displayName, px) {
        return new Spacing(displayName, px + "px");
    };
    Spacing.prototype.toString = function () {
        return this.px;
    };
    Spacing.prototype.getValue = function () {
        return parseFloat(this.px);
    };
    return Spacing;
}());
exports.Spacing = Spacing;
/**
 * We don't want breakpoints to change based on the user's default font
 * size, so for Breakpoints we specifically stringify them as pixels.
 */
var Breakpoint = /** @class */ (function (_super) {
    __extends(Breakpoint, _super);
    function Breakpoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breakpoint.fromPixels = function (displayName, px) {
        return new Breakpoint(displayName, px + "px");
    };
    return Breakpoint;
}(Spacing));
exports.Breakpoint = Breakpoint;
exports.spacing = {
    xxs: Spacing.fromPixels('xxs', 4),
    xs: Spacing.fromPixels('xs', 8),
    sm: Spacing.fromPixels('sm', 12),
    md: Spacing.fromPixels('md', 16),
    lg: Spacing.fromPixels('lg', 24),
    xl: Spacing.fromPixels('xl', 36),
    xl2: Spacing.fromPixels('xl2', 48),
    xl3: Spacing.fromPixels('xl3', 64),
    xl4: Spacing.fromPixels('xl4', 96),
    xl5: Spacing.fromPixels('xl5', 128)
};
//# sourceMappingURL=spacing.js.map